import { render, staticRenderFns } from "./contractsActs.vue?vue&type=template&id=44b84580&scoped=true&"
import script from "./contractsActs.vue?vue&type=script&lang=js&"
export * from "./contractsActs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b84580",
  null
  
)

export default component.exports